import { maskLicensePlateNumber } from './maskLicensePlateNumber';

let lastVirtualPageUrl: string | null = null;

export const getPageReferrer = (): string => {
  if (lastVirtualPageUrl) return lastVirtualPageUrl;
  if (typeof document === 'undefined') return '';
  return maskLicensePlateNumber(document.referrer || '');
};

export const setLastVirtualPageUrl = (pageUrl: string) => {
  lastVirtualPageUrl = pageUrl ? maskLicensePlateNumber(pageUrl) : null;
};

export const resetLastVirtualPageUrl = () => {
  lastVirtualPageUrl = null;
};
